/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ODataServiceDocument } from '../../models/o-data-service-document';

export interface Odata$JsonOdataMetadataFull$Params {
}

export function odata$JsonOdataMetadataFull(http: HttpClient, rootUrl: string, params?: Odata$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ODataServiceDocument>> {
  const rb = new RequestBuilder(rootUrl, odata$JsonOdataMetadataFull.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=full', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ODataServiceDocument>;
    })
  );
}

odata$JsonOdataMetadataFull.PATH = '/odata';
